import clsx from "clsx";
import { Row } from "antd";
import { RiHome6Line } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import React, { useMemo, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Layout } from "./styles";
import { PageInfo } from "../PageInfo";
import { Page } from "../../constants/brokers";
import { useBroker } from "../../contexts/BrokerContext";
import { IRPFBanner } from "../../pages/Home/IRPFBanner";
import { TabNavigator } from "../TabNavigator";

interface IPageWrapperProps {
  header?: boolean;
  sideBar?: boolean;
  overflow?: boolean;
  page?: string;
}

const PageWrapper: React.FC<IPageWrapperProps> = ({
  children,
  sideBar,
  header,
  overflow,
}) => {
  const { pathname } = useLocation();
  const { currentBroker } = useBroker();
  const [showIrpfBanner, setShowIrpfBanner] = useState(false);

  const currentPage = useMemo(
    () =>
      [
        {
          sidebar: true,
          header: true,
          path: "/",
          name: "Início",
          title: (
            <Row align="middle">
              <RiHome6Line size={20} color="var(--ant-primary-color)" />
              Início
            </Row>
          ),
        },
        // {
        //   sidebar: true,
        //   header: true,
        //   path: "/carteira",
        //   name: "Meus investimentos",
        //   title: (
        //     <Row align="middle">
        //       <GiWallet size={20} color="var(--ant-primary-color)" />
        //       Meus investimentos
        //     </Row>
        //   ),
        // },
        {
          sidebar: true,
          header: true,
          path: "/conta",
          name: "Minha conta",
          title: "Minha conta",
        },
        {
          sidebar: true,
          header: true,
          path: "/regulacao",
          name: "Regulação",
          title: "",
        },
        {
          sidebar: true,
          header: true,
          path: "/p/cadastrar",
          name: "Cadastre-se",
          title: "Cadastre-se",
        },
        {
          sidebar: true,
          header: true,
          path: "/p/login",
          name: "Entrar",
          title: "Entrar",
        },
        ...(currentBroker?.pages.reduce(
          (acc, cur) => [...acc, cur, ...(cur.subPages ?? [])],
          [] as Page[]
        ) || []),
      ].find(
        (page) =>
          pathname ===
          (page.path.substring(0, 1) === "/" ? page.path : `/${page.path}`)
      ),
    [pathname, currentBroker]
  );

  return (
    <>
      <IRPFBanner show={showIrpfBanner} setShow={setShowIrpfBanner} />
      <Layout className={clsx({ showIrpfBanner })}>
        {(sideBar ||
          (typeof currentPage?.sidebar === "boolean" &&
            currentPage?.sidebar)) && (
          <Sidebar pagePath={currentPage?.path || ""} />
        )}
        <Layout>
          {(header ||
            (typeof currentPage?.header === "boolean" &&
              currentPage?.header)) && (
            <Header
              id={currentPage?.name || ""}
              title={currentPage?.title || ""}
              icon={""}
            />
          )}
          <div className={clsx("content", "beauty-scrollbar", { overflow })}>
            {currentBroker.id === "mei" &&
              currentPage?.name === "Cadastre-se" && (
                <PageInfo
                  title="Faça a sua declaração IR do MEI"
                  subtitle="As informações do formulário são necessárias para prepararmos sua declaração"
                />
              )}
            {children}
          </div>
        </Layout>
        <TabNavigator />
      </Layout>
    </>
  );
};

export default PageWrapper;
